export interface KeyboardShortcut {
  key: string;
  meta?: boolean;
  ctrl?: boolean;
  shift?: boolean;
  mod?: boolean;
  handler: (event: KeyboardEvent) => void;
}

export function registerShortcut(shortcut: KeyboardShortcut, platform = detectPlatform()): () => void {
  const normalizedKey = shortcut.key.toLowerCase();
  const primaryModifier = resolveModifier(platform);

  const listener = (event: KeyboardEvent) => {
    if (
      event.key.toLowerCase() === normalizedKey &&
      (shortcut.mod
        ? primaryModifier === 'Meta'
          ? event.metaKey && !event.ctrlKey
          : event.ctrlKey && !event.metaKey
        : !!event.metaKey === !!shortcut.meta && !!event.ctrlKey === !!shortcut.ctrl) &&
      !!event.shiftKey === !!shortcut.shift
    ) {
      event.preventDefault();
      shortcut.handler(event);
    }
  };
  document.addEventListener('keydown', listener);
  return () => document.removeEventListener('keydown', listener);
}

export function detectPlatform(): 'mac' | 'windows' | 'linux' {
  if (typeof navigator === 'undefined') {
    return 'linux';
  }

  const platform = navigator.platform?.toLowerCase() ?? '';
  const userAgent = navigator.userAgent?.toLowerCase() ?? '';

  if (platform.includes('mac') || userAgent.includes('mac')) {
    return 'mac';
  }

  if (platform.includes('win') || userAgent.includes('win')) {
    return 'windows';
  }

  return 'linux';
}

export function resolveModifier(platform: 'mac' | 'windows' | 'linux' = detectPlatform()): 'Meta' | 'Control' {
  return platform === 'mac' ? 'Meta' : 'Control';
}
